import { h } from 'preact';

export function IconMagnifyingGlassPlus({ width = 16, height = 16, fill = 'currentColor' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      width={width}
      height={height}
      fill={fill}
      class="icon-magnifying-glass-plus"
    >
      <path d="M208 32a176 176 0 1 0 0 352 176 176 0 1 0 0-352zM0 208C0 93.1 93.1 0 208 0s208 93.1 208 208c0 48.3-16.5 92.7-44.1 128l133 133c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-133-133c-35.3 27.6-79.7 44.1-128 44.1C93.1 416 0 322.9 0 208zm232-80v56h56c13.3 0 24 10.7 24 24s-10.7 24-24 24h-56v56c0 13.3-10.7 24-24 24s-24-10.7-24-24v-56h-56c-13.3 0-24-10.7-24-24s10.7-24 24-24h56v-56c0-13.3 10.7-24 24-24s24 10.7 24 24z" />
    </svg>
  );
}
